import { type AnalyticsEvent } from '@shared/analytics';
const EXCLUDED = 'analytics_excluded_v1';
const VISITOR = 'analytics_visitor_v1';
function generateAnalyticsUuid(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  // getRandomValues is also available in non-secure HTTP browser contexts.
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return [hex.slice(0, 8), hex.slice(8, 12), hex.slice(12, 16), hex.slice(16, 20), hex.slice(20)].join('-');
}
const visit = generateAnalyticsUuid();
let visitor: string = visit;
let started = false;
try {
  const stored = localStorage.getItem(VISITOR);
  visitor =
    stored && /^[0-9a-f-]{36}$/i.test(stored) ? stored : generateAnalyticsUuid();
  localStorage.setItem(VISITOR, visitor);
} catch {
  /* 浏览器存储不可用时只在本页使用随机编号。 */
}
export function isAnalyticsExcluded() {
  try {
    return localStorage.getItem(EXCLUDED) === '1';
  } catch {
    return false;
  }
}
export function setAnalyticsExcluded(value: boolean) {
  try {
    localStorage.setItem(EXCLUDED, value ? '1' : '0');
  } catch {
    /* 浏览器存储不可用时无法记住，忽略。 */
  }
}
function skip() {
  return (
    isAnalyticsExcluded() ||
    /bot|crawler|spider|preview/i.test(navigator.userAgent)
  );
}
export function trackAnalytics(
  payload: Pick<AnalyticsEvent, 'kind'> & Partial<AnalyticsEvent>,
) {
  if (skip()) return;
  void fetch('/api/analytics/events', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    keepalive: true,
    body: JSON.stringify({
      id: generateAnalyticsUuid(),
      visitor,
      visit,
      ...payload,
    }),
  }).catch(() => undefined);
}
export function startAnalytics() {
  if (!started) {
    started = true;
    trackAnalytics({ kind: 'pv' });
  }
}
export function trackLegacyView(action: () => Promise<unknown>) {
  if (skip()) return;
  void action().catch(() => undefined);
}
